import React from "react";
import Nav from "./Components/Nav";
import Footer from "./Components/Footer";
import CHUKHomeBody from "./Components/BodyUKHome";
class CHUKHome extends React.Component {
  render() {
    return (
      <>
        <Nav />
        <CHUKHomeBody />
        <Footer />
      </>
    );
  }
}

export default CHUKHome;
